module.exports = __webpack_public_path__ + "img/Signature.eb0b19b0.svg";